// See: https://web.dev/cache-api-quick-guide/
import { csvParse } from 'd3-dsv';
import { useEffect, useState } from 'react';
import { environmentService } from '../services';

export const DATA_BASE_URL = '/tempData';

export const CACHE_NAME = 'cawp';
const cacheAvailable = false //'caches' in self;

function expirationKey(fullUrl: string): string {
	return `expiration_${fullUrl}`;
}

function setExpiration(fullUrl: string): void {
	// Expires in an hour
	localStorage[expirationKey(fullUrl)] =
		new Date().getTime() +
		parseInt(environmentService.get('VITE_BASE_CACHE_EXPIRE_TIME_S')) *
			1000 *
			60;
}

export function useFetch<T>(
	url: string,
	hostUrl = DATA_BASE_URL
): { isFetching: boolean; data: T } {
	const [data, setData] = useState<T | null>(null);
	const [isFetching, setIsFetching] = useState<boolean>(false);

	useEffect(() => {
		if (!url || url === '') {
			return;
		}
		const isCsv = fileIsCsv(url);
		// Url could change due to component state
		setData(null);

		const fullUrl = `${hostUrl}${url}`;
		console.log('full url', fullUrl);
		const fetchData = async (): Promise<void> => {
			if (!cacheAvailable) {
				//console.log('cache is not available', `Fetching ${fullUrl}`);
				const response = await fetch(fullUrl);
				 
				setData(await parseData(response, isCsv));
				return;
			}

			const cache = await caches.open(CACHE_NAME);

			const request = new Request(fullUrl);
			const cacheMatches = await cache.match(request);
			 
			const expiration = localStorage[expirationKey(fullUrl)];

			const expired =
				 
				!expiration || new Date().getTime() >= parseInt(expiration, 10);

			if (cacheMatches !== undefined && !expired) {
				 
				const cacheData = await cacheMatches.json();

				 
				setData(cacheData);
			} else {
				const requestOptions: RequestInit = {
					redirect: 'follow',
					cache: 'no-store'
				};

				console.log(`Fetching: ${fullUrl}`);
				const response = await fetch(fullUrl, requestOptions);

				 
				const resData = await parseData(response, isCsv);

				 
				setData(resData);

				setExpiration(fullUrl);
				await cache.put(request, new Response(JSON.stringify(resData)));
			}
		};
		setIsFetching(true);
		fetchData()
			.catch((e) => console.error(e))
			.finally(() => setIsFetching(false));
	}, [hostUrl, url]);

	return { isFetching, data: data as unknown as T };
}

function fileIsCsv(url: string) {
	return url.indexOf('.csv') !== -1 || url.indexOf('.CSV') !== -1;
}

async function parseData(response: Response, isCsv: boolean) {
	 
	return isCsv ? await parseCsvData(response) : await response.json();
}

async function parseCsvData(response: Response) {
	const csvText = await response.text();
	 
	const data = csvParse(csvText) || [];
	return data as [];
}
